._1kagu2y0 {
  font-weight: 400;
  font-size: 14px;
  line-height: 1.3;
  letter-spacing: -0.01em;
  color: var(--_1qu8za24);
  margin: -16px 70px 24px 0;
}
._1kagu2y1 {
  display: flex;
  gap: 8px;
  margin-top: 48px;
}
._1kagu2y1 > button {
  flex: 1 1 0;
}
._1kagu2y2 {
  background: var(--_1qu8za2d);
  border-radius: 64px;
  padding-left: 12px;
  padding-right: 4px;
  height: 32px;
}
._1kagu2y3 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}